import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { RequiredEventDialogComponent } from './required-event-dialog.component';

@NgModule({
    imports: [SharedPageModule, NgbTooltipModule],
    declarations: [RequiredEventDialogComponent]
})
export class RequiredEventDialogModule { }
